// Local-time date helpers. Never use toISOString for YYYY-MM-DD — a Date built
// from local components gets shifted to UTC and can slip back a day for viewers
// west of GMT (or forward for viewers east of it).

const pad = n => String(n).padStart(2, "0");

// YYYY-MM-DD from a Date, in its own local timezone
export const iso = d => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;

// Parse YYYY-MM-DD as a *local* date (noon so DST transitions don't cross a day)
export const parseISO = v => v ? new Date(`${v}T12:00:00`) : null;

export const addDays = (d, n) => { const x = new Date(d); x.setDate(x.getDate() + n); return x; };

export const nights = (a, b) =>
  a && b ? Math.max(1, Math.round((parseISO(b) - parseISO(a)) / 86400000)) : 0;

export const fmtShort = v => {
  const d = parseISO(v);
  return d ? d.toLocaleDateString("en-US", { month: "short", day: "numeric" }) : "";
};

export const fmtLong = v => {
  const d = parseISO(v);
  return d ? d.toLocaleDateString("en-US", { weekday: "short", month: "short", day: "numeric" }) : "";
};
